import { css } from "@emotion/react";

// Preserve compact legacy screens while opt-in themed inputs use MUI's own
// geometry (including portal dialogs, autocomplete, selects and multiline).
// Keep this shared with offline app-like browser fixtures to catch collisions.
export default css`
  legend { display: none; }
  .MuiOutlinedInput-root:not([data-standard-geometry]) .MuiOutlinedInput-notchedOutline {
    top: 0px !important;
  }
  .MuiOutlinedInput-root:not([data-standard-geometry]) .MuiOutlinedInput-input {
    padding: 5px 0 4px 15px !important;
  }
  .MuiOutlinedInput-root[data-standard-geometry] .MuiOutlinedInput-notchedOutline legend {
    display: block;
  }
`;
